import * as Messaging from "firebase/messaging";
import { onMessage, getMessaging } from "firebase/messaging";
import { Logger } from "../HelperFunctions";
import Storage from "../storage/StorageFunctions";
import { uploadDeviceToken } from "../Helpers";
import Constants from "../Constants";
import { initializeApp } from "firebase/app";
import { toast } from "react-toastify";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const getDeviceTokenForNotification = async () => {
  const deviceToken = await Storage.getData(
    Constants.LocalStoreConstant.DEVICE_TOKEN
  );  
  if (deviceToken) {
    return deviceToken;
  } else {
    // const token = await messaging.getToken({
    //   vapidKey: process.env.REACT_APP_FIREBASE_V_API_KEY,
    // });
    // return token;
    
  }
}

let messaging: any = null;

export const NotificationManagerInit = async () => {
  try {
    const hasPermission = await requestNotificationPermission();
    if (!hasPermission) {
      Logger("Notification permissions not granted.");
      return;
    }

    const app = initializeApp(firebaseConfig);

    messaging = getMessaging(app);

    onMessage(messaging, (payload) => {
      toast.success(
        "New Notification: " + payload?.notification?.title ||
          payload?.data?.title
      );
    });

    if (messaging) {
      const deviceToken = await getDeviceTokenForNotification();

      if (deviceToken) {
        await Storage.storeObjectData(
          Constants.LocalStoreConstant.DEVICE_TOKEN,
          deviceToken
        );
        const userToken = await Storage.getData(
          Constants.LocalStoreConstant.ACCESS_TOKEN
        );
        const deviceUploaded = await Storage.getData(
          Constants.LocalStoreConstant.DEVICE_UPLOADED
        );
        if (userToken && (!deviceUploaded || deviceUploaded == "")) {
          uploadDeviceToken(userToken);
        }
      } else {
        Logger("No registration token available.");
      }
    }
  } catch (err) {
    Logger("An error occurred while retrieving token. " + err);
  }
};

const requestNotificationPermission = async (): Promise<boolean> => {
  try {
    if (Notification.permission === "granted") {
      return true;
    } else if (Notification.permission === "default") {
      const permission = await Notification.requestPermission();
      return permission === "granted";
    } else {
      Logger(
        "Notifications are blocked. Please enable them in browser settings."
      );
      return false;
    }
  } catch (error) {
    Logger("Error requesting notification permission: " + error);
    return false;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    Messaging.onMessage(messaging as any, (payload) => {
      resolve(payload);
    });
  });
